import { RawCountry } from "@/entities/country";

export type RawUserCountries = {
  readonly countries: RawCountry[];
};

export const iniRawCountries: RawUserCountries = {
  countries: Array.of(),
};
